module.exports = __webpack_public_path__ + "img/77.2b05dc76.png";